/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable @nx/enforce-module-boundaries */
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';

import type { IManagementUser } from '@license-manager/types';

@Module({ namespaced: true })
export default class UserManagement extends VuexModule {
  managementUsersWithCount: [IManagementUser[], number] = [[], 0];
  isLoading = false;

  @Mutation
  setLoading(loadingState = false) {
    this.isLoading = loadingState;
  }

  @Mutation
  setmanagementUsersWithCount(data: [IManagementUser[], number]) {
    this.managementUsersWithCount = data;
  }

  @Action({ rawError: true })
  async updateOrCreateUser(payload: { id?: number; user: IManagementUser }) {
    this.context.commit('setLoading', true);

    try {
      if (payload.id) {
        const resp = await $http.put(
          'managementusers' + '/' + payload.id,
          payload.user
        );
      } else {
        const resp = await $http.post('managementusers' + '/', payload.user);
      }
      this.context.dispatch('loadManagementUsers');
    } finally {
      this.context.commit('setLoading', false);
    }
  }

  @Action({ rawError: true })
  async deleteUser(id) {
    this.context.commit('setLoading', true);
    try {
      await $http.delete(`/managementusers/${id}`);
      this.context.dispatch('loadManagementUsers');
    } finally {
      this.context.commit('setLoading', false);
    }
  }

  @Action
  async loadManagementUsers() {
    this.context.commit('setLoading', true);
    const managementUsersWithCount = await $http
      .get('managementusers')
      .then((response) => response.data);
    this.context.commit('setLoading', false);
    this.context.commit(
      'setmanagementUsersWithCount',
      managementUsersWithCount
    );
  }

  get managementUsers(): IManagementUser[] {
    return this.managementUsersWithCount[0];
  }
}
